angular.module('skeyenoteWebApp').directive('codeEditor', CodeEditorDirective);

function CodeEditorDirective($templateRequest, $compile) {
  return {
    restrict: 'AE',
    scope: {
      paragraphId: '=paragraphId',
      paragraph: '=paragraphContext',
      dirtyText: '=dirtyText',
      originalText: '=originalText',
      onLoad: '=onLoad',
      revisionView: '=revisionView',
    },
    link: function(scope, element, attrs, controller) {
      $templateRequest('app/notebook/paragraph/code-editor/code-editor.directive.html').then(function(editorHtml) {
        let editor = angular.element(editorHtml);
        editor.attr('id', scope.paragraphId + '_editor');
        element.append(editor);
        $compile(editor)(scope);
        console.debug('codeEditor directive revision view is ' + scope.revisionView);
      });
    },
  };
}
